import ThemeContext from "@suid/system/ThemeContext";
function ThemeProvider(props) {
    return (<ThemeContext.Provider value={props.theme}>
      {props.children}
    </ThemeContext.Provider>);
}
export default ThemeProvider;
